import type { KbGapInboxSectionProps } from "./kbGapInboxTypes";

type Props = Pick<
  KbGapInboxSectionProps,
  | "gapInboxStatusFilter"
  | "gapInboxLoading"
  | "gapInboxPageSize"
  | "gapInboxTestingOnly"
  | "gapInboxListTotal"
  | "gapInboxPage"
  | "onGapInboxStatusFilterChange"
  | "onRefreshGapInbox"
  | "onGapInboxPageSizeChange"
  | "onGapInboxTestingOnlyChange"
>;

export function KbGapInboxToolbar(props: Props) {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <select
        className="rounded-lg border border-gray-300 px-2 py-2 text-sm dark:border-zinc-600 dark:bg-zinc-900/60 dark:text-zinc-100"
        value={props.gapInboxStatusFilter}
        onChange={(event) => props.onGapInboxStatusFilterChange(event.target.value as KbGapInboxSectionProps["gapInboxStatusFilter"])}
      >
        <option value="">all statuses</option>
        <option value="open">open</option>
        <option value="in_progress">in progress</option>
        <option value="accepted">accepted</option>
        <option value="done">done</option>
        <option value="dismissed">dismissed</option>
      </select>
      <button
        type="button"
        className="rounded-lg bg-indigo-600 px-3 py-2 text-sm font-medium text-white disabled:opacity-50"
        onClick={() => props.onRefreshGapInbox(props.gapInboxStatusFilter || undefined, props.gapInboxTestingOnly)}
        disabled={props.gapInboxLoading}
      >
        {props.gapInboxLoading ? "Loading…" : "Refresh"}
      </button>
      <label className="flex items-center gap-1 text-xs text-gray-600 dark:text-zinc-300">
        <span className="whitespace-nowrap">Page size</span>
        <select
          className="rounded-lg border border-gray-300 px-2 py-1.5 text-xs dark:border-zinc-600 dark:bg-zinc-900/60 dark:text-zinc-100"
          value={props.gapInboxPageSize}
          onChange={(e) => props.onGapInboxPageSizeChange(e.target.value === "5" ? 5 : 10)}
          disabled={props.gapInboxLoading}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
        </select>
      </label>
      <button
        type="button"
        className={
          "rounded-lg border px-3 py-2 text-xs font-medium " +
          (props.gapInboxTestingOnly
            ? "border-indigo-400 bg-indigo-50 text-indigo-800 dark:border-indigo-600 dark:bg-indigo-950/45 dark:text-indigo-200"
            : "border-gray-300 bg-white text-gray-700 dark:border-zinc-600 dark:bg-zinc-900/60 dark:text-zinc-200")
        }
        onClick={() => props.onGapInboxTestingOnlyChange(!props.gapInboxTestingOnly)}
        disabled={props.gapInboxLoading}
      >
        {props.gapInboxTestingOnly ? "KB testing only: ON" : "KB testing only"}
      </button>
      {props.gapInboxListTotal > 0 ? (
        <span className="text-xs text-gray-500 dark:text-zinc-400">
          Page {props.gapInboxPage + 1} of {Math.max(1, Math.ceil(props.gapInboxListTotal / props.gapInboxPageSize))} · {props.gapInboxListTotal} total
          {props.gapInboxTestingOnly ? " (testing filter)" : ""}
        </span>
      ) : null}
    </div>
  );
}
